(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["props-pagina-texto"] && !Shopify.designMode) return;
  try {
    
  class PropsToc extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('.props-pagina__content');
      const nav = this.querySelector('.props-pagina__toc');
      if (!content || !nav) return;

      const headings = content.querySelectorAll('h2');
      // El índice solo aporta con más de cuatro H2 (brief §6)
      if (headings.length <= 4) return;

      const list = document.createElement('ul');
      headings.forEach((h, i) => {
        if (!h.id) h.id = 'seccion-' + (i + 1);
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
      nav.appendChild(list);
      nav.hidden = false;
      this.classList.add('props-pagina--con-indice');
    }
  }
  if (!customElements.get('props-toc')) customElements.define('props-toc', PropsToc);

  } catch(e) { console.error(e); }
})();
})();
